<template>
  <div :class="['best-products', page]">
    <div class="container">
      <h2 v-if="page">
        {{ $t(`fields.${page}`) }}
      </h2>
      <div class="buttons">
        <slot name="buttons" />
      </div>
      <div class="products-container">
        <product-box v-for="(product, index) in products" :key="index" :product="product" />
      </div>
    </div>
    <b-loading :is-full-page="false" :active.sync="loadingProductsPage" :can-cancel="false" />
  </div>
</template>

<script>
import ProductBox from '~/marketplace-front-core/components/products/ProductBox'
export default {
  components: { ProductBox },
  props: {
    products: {
      type: Array,
      default () {
        return []
      }
    },
    page: {
      type: String,
      default: ''
    }
  },
  computed: {
    loadingProductsPage () {
      return this.$store.state.page.loadingProductsPage
    }
  }
}
</script>
